import React from "react";
import PropTypes from "prop-types";
import { load } from "actions/advancedScreeningResultsActions";
import ScreeningGroup from "./screeningGroup";
import { Loader, Button } from "cxa-components";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import MarkerLegend from "./markerLegend";
import BasicScreeningResults from "./basicScreeningResults";
import { Notification } from "@cxagroup/casper";

// Redux
import { connect } from "react-redux";
import { injectIntl, FormattedMessage, intlShape } from "react-intl";
import messages from "components/messagesDescription";

class AdvancedScreeningResults extends React.Component {
  constructor(props) {
    super(props);

    this.handleLoad = this.handleLoad.bind(this);
    this.goToLaunchPad = this.goToLaunchPad.bind(this);
  }

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad(e) {
    if (e) {
      e.preventDefault();
    }

    this.props.load();
  }

  goToLaunchPad() {
    this.props.push("/wellness/launchpad");
  }

  render() {
    const { error, response, fetching, intl } = this.props;

    if (fetching) {
      return <Loader />;
    }

    if (!response || !response.isSuccess) {
      return null;
    }

    const hasBasicScreening =
      response.assessmentStatus && response.assessmentStatus.basicScreeningCompleted === "true";
    const hasAdvancedScreening =
      response.assessmentStatus && response.assessmentStatus.advancedScreeningCompleted === "true";

    if (error || !(hasBasicScreening || hasAdvancedScreening)) {
      return (
        <div>
          <h2>{intl.formatMessage(messages.screening.healthScreeningTitle)}</h2>
          <Notification
            level={Notification.level.notification}
            message={intl.formatMessage(messages.advancedScreeningResultNotYetAvailableDescription)}
          />
          <p>
            <Button primary type="button" className="previous" onClick={this.goToLaunchPad}>
              {intl.formatMessage(messages.launchPadLinkDescription)}
            </Button>
          </p>
        </div>
      );
    }

    if (!response || !response.isSuccess) {
      return null;
    }

    const screeningResults =
      hasAdvancedScreening &&
      response.categories.map((group, idx) => (
        <ScreeningGroup key={group.biomarkerCategoryId || idx} data={group} basic={false} />
      ));

    return (
      <div>
        <h2>{intl.formatMessage(messages.screening.healthScreeningTitle)}</h2>
        <MarkerLegend />
        {hasBasicScreening && <BasicScreeningResults />}
        {hasAdvancedScreening && (
          <p>
            <FormattedMessage
              {...messages.lastUpdateTextDescription}
              values={{
                when: <FormattedCustomDate value={response.lastUpdatedOn} />,
                who: response.lastUpdatedBy,
              }}
            />
          </p>
        )}
        {screeningResults}
      </div>
    );
  }
}

AdvancedScreeningResults.propTypes = {
  error: PropTypes.object,
  response: PropTypes.object,
  details: PropTypes.object,
  load: PropTypes.func,
  fetching: PropTypes.bool,
  push: PropTypes.func,
  intl: intlShape.isRequired,
};

const mapStateToProps = function(store) {
  return {
    error: store.advancedScreeningResults.error,
    response: store.advancedScreeningResults.response,
    fetching: store.advancedScreeningResults.fetching,
  };
};

const mapDispatchToProps = {
  load,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdvancedScreeningResults)
);



// WEBPACK FOOTER //
// ./components/employee/wellness/advancedScreeningResults.jsx